import VinWonderList from './VinWonderList';

export default VinWonderList;
